import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import LoadingScreen from "../../organisms/LoadingScreen";
import {
  QUERY_VENTAS_POR_PAGAR,
  useObtenerVentasPorPagar,
} from "../../../services/ventasServicios";
import MasterDetailSection from "./MasterDetailSection";
import { useQueryClient } from "@tanstack/react-query";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/ventas",
    label: "Ventas",
  },
  {
    path: "/por_pagar",
    label: "Ventas por pagar",
    isActive: true,
  },
];

function VentasPorPagar() {
  const queryClient = useQueryClient();
  const { data, isLoading, isSuccess } = useObtenerVentasPorPagar();
  
  const resetTable = () => {
    queryClient.invalidateQueries([QUERY_VENTAS_POR_PAGAR]);
  };

  return (
    <Page
      description="Visualiza ventas pendientes de pago y registra abonos."
      title="Ventas por pagar"
      breadCrumbs={breadCrumbs}
    >
      <LoadingScreen isLoading={isLoading} />
      {data && isSuccess && (
        <MasterDetailSection items={data} resetTable={resetTable} />
      )}
    </Page>
  );
}

export default VentasPorPagar;
